export default __webpack_public_path__ + "static/media/center-left.84cc26aa.png";